import axiosInstance from './axiosInstance';
import { variables } from './variables';

const API_URL = variables.BRAND_API;

// Fetch all brands
export const fetchBrands = async () => {
  const response = await axiosInstance.get(API_URL);
  return response.data;
};
